import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { Typography } from 'antd';

import { Row } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import LinkIcon from '@/shared/icons/misc/link.svg';
import UnlinkIcon from '@/shared/icons/misc/unlink.svg';
import { CollectionName } from '@/shared/lib/sj-orm/constants';

import { DataRow } from './types';

export const useColumnDefs = () => {
  const { t } = useTranslation('documents', { keyPrefix: 'unlinkModal' });

  return [
    {
      key: '1',
      title: t('object'),
      dataIndex: 'object',
      render: (collectionName: CollectionName) => (
        <Typography.Text>{collectionName}</Typography.Text>
      ),
    },
    {
      key: '2',
      title: t('name'),
      dataIndex: 'name',
      render: (name: string, record: DataRow) => {
        return (
          <Link
            href={`/${record.collectionName}/${record.id}`}
            style={{ color: COLORS.link, fontWeight: 700 }}
          >
            {name}
          </Link>
        );
      },
    },
    {
      key: '3',
      title: t('status'),
      dataIndex: 'isLinked',
      render: (isLinked: boolean) => (
        <Row gap={4} alignItems="center">
          <Image src={isLinked ? LinkIcon : UnlinkIcon} width={16} height={16} alt="" />
          <Typography.Text>{isLinked ? t('linked') : t('unlinked')}</Typography.Text>
        </Row>
      ),
    },
  ];
};
